import { createSlice } from '@reduxjs/toolkit';

import { INTERVALS } from './constants/intervals';

const INITIAL_STATE = {
  scheduling: {
    selectedDate: '',
    selectedTime: '',
    selectedSchedulingTime: '',
    intervals: [...INTERVALS],
  },
};

export const SchedulingSlice = createSlice({
  name: 'scheduling',
  initialState: INITIAL_STATE,
  reducers: {
    setSelectedDate: (state, { payload }) => {
      state.scheduling.selectedDate = payload;
    },
    setSelectedTime: (state, { payload }) => {
      state.scheduling.selectedTime = payload;
    },
    setSelectedSchedulingTime: (state, { payload }) => {
      state.scheduling.selectedSchedulingTime = payload;
    },
    setIntervals: (state, { payload }) => {
      state.scheduling.intervals = payload;
    },
    resetSchedulingSlice: () => INITIAL_STATE,
  },
});

export const {
  setSelectedDate,
  setSelectedTime,
  setSelectedSchedulingTime,
  setIntervals,
  resetSchedulingSlice,
} = SchedulingSlice.actions;

export default SchedulingSlice.reducer;

export const selectorSelectedDateScheduling = state =>
  state.scheduling.scheduling.selectedDate;
export const selectorSelectedTimeScheduling = state =>
  state.scheduling.scheduling.selectedTime;
export const selectorSelectedSchedulingTime = state =>
  state.scheduling.scheduling.selectedSchedulingTime;
export const selectorIntervalsScheduling = state =>
  state.scheduling.scheduling.intervals;
